<template>
  <div style="display:none"></div>
</template>

<script>
import { useCompanyStore, COMPANY_REFRESH_INTERVAL_MS } from '@/store/company'

export default {
  name: 'CompanySyncPoller',
  data () {
    return {
      pollInterval: null
    }
  },
  mounted () {
    const companyStore = useCompanyStore()
    if (!companyStore.isPro) return
    companyStore.fetchCompany()
    this.pollInterval = setInterval(this.refresh, COMPANY_REFRESH_INTERVAL_MS)
  },
  beforeDestroy () {
    clearInterval(this.pollInterval)
    // The layout unmounts on logout, so the next user starts without this one's
    // record rather than seeing it until the first fetch lands.
    useCompanyStore().$reset()
  },
  methods: {
    refresh () {
      useCompanyStore().fetchCompany()
    }
  }
}
</script>
